<template>
    <div class="ui vertical printable segment" ref="report">
        <div id="report-text">
            <section class="pdf-first-section">
                <section class="ui vertical segment">
                    <div class="ui two column middle aligned stackable grid">
                        <div class="column">
                            <div class="ui huge header" ref="report-title" id="report-title">{{ $t('components.report.title') }}</div>
                        </div>
                        <div class="right aligned computer only column">
                            
                        </div>
                    </div>
                </section>
                <section class="ui vertical segment">
                    <div class="ui very light grey segment">
                        <div class="ui stackable doubling four column grid">
                            <div class="nine wide column">
                                <div class="ui tiny dark grey attached header">{{ $t('components.report.header.project') }}</div>
                                <div class="ui black attached header">{{ project.scope.attributes.name }}</div>
                            </div>
                            <div class="column">
                                <div class="ui tiny dark grey attached header">{{ $t('components.report.header.date') }}</div>
                                <p>{{ $d(new Date()) }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="ui segment">
                        <div class="ui stackable doubling four column grid">
                            <div class="column">
                                <div class="ui tiny dark grey attached header">{{ $t('components.report.header.location') }}</div>
                                <p>{{ project.scope.attributes.address.city }}, {{ project.scope.attributes.address.country }}</p>
                            </div>
                            <div v-if="user" class="column">
                                <div class="ui tiny dark grey attached header">Referenz</div>
                                <p>---</p>
                            </div>
                            <div class="six wide column"></div>
                        </div>
                        <div v-if="user" class="ui stackable doubling four column grid">
                            <div class="column">
                                <div class="ui tiny dark grey attached header">Ansprechpartner</div>
                                <p>Max Mustermann</p>
                            </div>
                            <div class="column">
                                <div class="ui tiny dark grey attached header">Unternehmen</div>
                                <p>Company GmbH &amp; Co.KG</p>
                            </div>
                            <div class="column">
                                <div class="ui tiny dark grey attached header">Telefon</div>
                                <p>01234 / 98 76 54</p>
                            </div>
                            <div class="column">
                                <div class="ui tiny dark grey attached header">E-Mail</div>
                                <p>max.mustermann@company.com</p>
                            </div>
                            <div class="column">
                                <div class="ui tiny dark grey attached header">Straße, Nr.</div>
                                <p>Beispiel Alle 100</p>
                            </div>
                            <div class="column">
                                <div class="ui tiny dark grey attached header">Postleitzahl</div>
                                <p>12345</p>
                            </div>
                            <div class="column">
                                <div class="ui tiny dark grey attached header">Stadt</div>
                                <p>Berlin</p>
                            </div>
                            <div class="column">
                                <div class="ui tiny dark grey attached header">Land</div>
                                <p>Deutschland</p>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="ui vertical padded left aligned segment">
                    <div class="ui wide text container">
                        <div class="ui large header">{{ $t('components.report.project.savings.title') }}</div>
                        <div class="ui stackable doubling equal width stretched center aligned grid">
                            <div class="twelve wide column">
                                <div class="ui light header">{{ $t('components.report.project.savings.monetary.title', { currency }) }}:</div>
                            </div>
                            <div class="column">
                                <div class="ui bordered segment">
                                    <div class="ui small blue statistic">
                                        <div class="value">
                                            <span>{{ total(project.scope, 'monetary') | format($i18n.locale) }}</span>
                                        </div>
                                        <div class="label">
                                            {{ $t('components.report.units.monetary.year', { currency }) }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="column">
                                <div class="ui bordered  segment">
                                    <div class="ui small blue statistic">
                                        <div class="value">
                                            max.
                                            <span>{{ total(project.scope, 'monetary') * 10 | format($i18n.locale) }}</span>
                                        </div>
                                        <div class="label">
                                            {{ $t('components.report.units.monetary.decade', { currency }) }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="ui stackable doubling equal width stretched center aligned grid">
                            <div class="twelve wide column">
                                <div class="ui light header">{{ $t('components.report.project.savings.environmental.title') }}:</div>
                            </div>
                            <div class="column">
                                <div class="ui bordered  segment">
                                    <div class="ui small green statistic">
                                        <div class="value">
                                            <span>{{ total(project.scope, 'energetic') | format($i18n.locale) }}</span>
                                        </div>
                                        <div class="label">
                                            {{ $t('components.report.units.environmental.watt') }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="column">
                                <div class="ui bordered  segment">
                                    <div class="ui small green statistic">
                                        <div class="value">
                                            <span>{{ total(project.scope, 'ecologically') | format($i18n.locale) }}</span>
                                        </div>
                                        <div class="label">
                                            {{ $t('components.report.units.environmental.carbon') }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="ui vertical padded center aligned segment">
                    <div class="ui wide text container">
                        <div class="ui doubling stackable two column bottom aligned grid">
                            <div class="column">
                                <div class="ui header">{{ $t('components.report.header.amortization.title') }}</div>
                                <ui-chart v-bind:datasets="[{
                                    label: $t('components.report.header.amortization.savings'),
                                    data: amortizations(project.scope),
                                    backgroundColor: 'rgba(82, 169, 0, 1)',
                                    borderColor: 'rgba(82, 169, 0, 1)',
                                    fill: false
                                }, {
                                    label: $t('components.report.header.amortization.investion'),
                                    data: investments(),
                                    backgroundColor: 'rgba(0, 147, 217, 1)',
                                    borderColor: 'rgba(0, 147, 217, 1)',
                                    fill: false
                                }]" v-bind:labels="Array.from(Array(10).keys())" v-bind:axes="{x: $t('components.report.header.amortization.x'), y: $t('components.report.header.amortization.y')}"></ui-chart>
                            </div>
                            <div class="column">
                                <div class="ui header">{{ $t('components.report.header.temperature.title', {location: project.scope.attributes.address.city}) }}</div>
                                <ui-chart v-bind:datasets="[{
                                    label: $t('components.report.header.temperature.night'),
                                    data: values(project.scope, 'night-temperature'),
                                    backgroundColor: 'rgba(0, 94, 153, 1)',
                                    borderColor: 'rgba(0, 94, 153, 1)',
                                    fill: false
                                }, {
                                    label: $t('components.report.header.temperature.day'),
                                    data: values(project.scope, 'day-temperature'),
                                    backgroundColor: 'rgba(0, 147, 217, 1)',
                                    borderColor: 'rgba(0, 147, 217, 1)',
                                    fill: false
                                }]" v-bind:labels="months" v-bind:axes="{x: $t('components.report.header.temperature.x'), y: $t('components.report.header.temperature.y')}"></ui-chart>
                            </div>
                        </div>
                        <div class="ui divider"></div>
                    </div>
                </section>
            </section>
            <section class="pdf-second-section">
                <div class="ui wide text container" data-pagebreak-before="">
                    <div class="ui large header">{{ $t('components.report.data.title') }}</div>
                </div>
                <section 
                    v-for="building of $store.getters.children(project.scope)" 
                    v-bind:key="building.id" 
                    class="ui vertical padded left aligned segment building pdf-break-after"
                    
                    >
                    <div class="ui wide text container">
                        <div class="ui very light grey segment">
                            <div class="ui header">
                                <i class="existing building site icon"></i>
                                <div class="content">{{ $t('components.report.building.title', {identifier: building.attributes.name}) }}</div>
                            </div>
                            <div class="ui segment savings">
                                <div class="ui small header">{{ $t('components.report.building.savings.title') }}</div>
                                <div class="ui stackable doubling equal width stretched center aligned grid">
                                    <div class="column">
                                        <div class="ui bordered small compressed segment">
                                            <div class="ui tiny blue statistic">
                                                <div class="value">
                                                    <span>{{ total(building, 'monetary') | format($i18n.locale) }}</span>
                                                </div>
                                                <div class="label">
                                                    {{ $t('components.report.units.monetary.year', { currency }) }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="column">
                                        <div class="ui bordered small compressed segment">
                                            <div class="ui tiny blue statistic">
                                                <div class="value">
                                                    max.
                                                    <span>{{ total(building, 'monetary') * 10 | format($i18n.locale) }}</span>
                                                </div>
                                                <div class="label">
                                                    {{ $t('components.report.units.monetary.decade', { currency }) }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="ui stackable doubling equal width stretched center aligned grid">
                                    <div class="column">
                                        <div class="ui bordered small compressed segment">
                                            <div class="ui tiny green statistic">
                                                <div class="value">
                                                    <span>{{ total(building, 'energetic') | format($i18n.locale) }}</span>
                                                </div>
                                                <div class="label">
                                                    {{ $t('components.report.units.environmental.watt') }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="column">
                                        <div class="ui bordered small compressed segment">
                                            <div class="ui tiny green statistic">
                                                <div class="value">
                                                    <span>{{ total(building, 'ecologically') | format($i18n.locale) }}</span>
                                                </div>
                                                <div class="label">
                                                    {{ $t('components.report.units.environmental.carbon') }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="ui vertical segment building-data">
                                <div class="ui segment">
                                    <div class="ui small header">{{ $t('components.report.data.building.title') }}</div>
                                    <div class="ui stackable doubling four column celled grid">
                                        <div class="row">
                                            <div class="column">
                                                <div class="ui tiny dark grey attached header">{{ $t('scopes.building.variables.heatingTemperature.label') }}</div>
                                                <p v-if="building.attributes.heatingTemperature.value !== null">{{ building.attributes.heatingTemperature.value }} {{ $config.get('scopes.building.variables.heatingTemperature.label') }}</p>
                                                <p v-else>-</p>
                                            </div>
                                            <div class="column">
                                                <div class="ui tiny dark grey attached header">{{ $t('scopes.building.variables.heatingEfficiency.label') }}</div>
                                                <p v-if="building.attributes.heatingEfficiency.value !== null">{{ building.attributes.heatingEfficiency.value * 100 }} {{ $config.get('scopes.building.variables.heatingEfficiency.label') }}</p>
                                                <p v-else>-</p>
                                            </div>
                                            <div class="column">
                                                <div class="ui tiny dark grey attached header">{{ $t('scopes.building.variables.operatingType.label') }}</div>
                                                <p v-if="building.attributes.operatingType !== null">{{ $t(`scopes.building.variables.operatingType.items.${building.attributes.operatingType}.label`) }}</p>
                                                <p v-else>-</p>
                                            </div>
                                            <div class="column">
                                                <div class="ui tiny dark grey attached header">{{ $t('scopes.building.variables.heatingType.label') }}</div>
                                                <p v-if="building.attributes.heatingType !== null">{{ $t(`scopes.building.variables.heatingType.items.${building.attributes.heatingType}.label`) }}</p>
                                                <p v-else>-</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div 
                                v-for="shaft of $store.getters.children(building)" 
                                v-bind:key="shaft.id" 
                                class="ui vertical shaft segment pdf-avoid-break"
                            >
                                <div class="ui secondary segment">
                                    <div class="ui small header">{{ $t('components.report.shaft.title', {identifier: shaft.attributes.name}) }}</div>
                                    <div class="ui vertical compressed segment">
                                        <div class="ui tiny header">{{ $t('components.report.shaft.savings.title') }}</div>
                                        <div class="ui stackable doubling equal width stretched center aligned grid">
                                            <div class="column">
                                                <div class="ui bordered small compressed transparent segment">
                                                    <div class="ui mini blue statistic">
                                                        <div class="value">
                                                            <span>{{ total(shaft, 'monetary') | format($i18n.locale) }}</span>
                                                        </div>
                                                        <div class="label">
                                                            {{ $t('components.report.units.monetary.year', { currency }) }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="column">
                                                <div class="ui bordered small compressed transparent segment">
                                                    <div class="ui mini blue statistic">
                                                        <div class="value">
                                                            max.
                                                            <span>{{ total(shaft, 'monetary') * 10 | format($i18n.locale) }}</span>
                                                        </div>
                                                        <div class="label">
                                                            {{ $t('components.report.units.monetary.decade', { currency }) }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ui stackable doubling equal width stretched center aligned grid">
                                            <div class="column">
                                                <div class="ui bordered small compressed transparent segment">
                                                    <div class="ui mini green statistic">
                                                        <div class="value">
                                                            <span>{{ total(shaft, 'energetic') | format($i18n.locale) }}</span>
                                                        </div>
                                                        <div class="label">
                                                            {{ $t('components.report.units.environmental.watt') }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="column">
                                                <div class="ui bordered small compressed transparent segment">
                                                    <div class="ui mini green statistic">
                                                        <div class="value">
                                                            <span>{{ total(shaft, 'ecologically') | format($i18n.locale) }}</span>
                                                        </div>
                                                        <div class="label">
                                                            {{ $t('components.report.units.environmental.carbon') }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ui vertical compressed segment">
                                        <div class="ui tiny header">{{ $t('components.report.data.shaft.title') }}</div>
                                        <div class="ui stackable doubling four column celled grid">
                                            <div class="row">
                                                <div class="column">
                                                    <div class="ui tiny dark grey attached header">{{ $t('scopes.shaft.variables.providedHeight.label') }}</div>
                                                    <p v-if="shaft.attributes.providedHeight.value !== null">{{ shaft.attributes.providedHeight.value }} {{ $config.get('scopes.shaft.variables.providedHeight.label') }}</p>
                                                    <p v-else>-</p>
                                                </div>
                                                <div class="column">
                                                    <div class="ui tiny dark grey attached header">{{ $t('scopes.shaft.variables.upperVent.label') }}</div>
                                                    <p v-if="shaft.attributes.upperVent.value !== null">
                                                        {{ shaft.attributes.upperVent.value }} {{ $config.get('scopes.shaft.variables.upperVent.label') }}
                                                        <template v-if="!!shaft.attributes.minVentAreaRuleset && shaft.attributes.upperVent.function == 'de.bluekit.simulation.computation.RulesetBasedUpperVentEstimator'">
                                                            <br/>
                                                            ({{ $t(`scopes.shaft.variables.minVentAreaRuleset.items.${shaft.attributes.minVentAreaRuleset}.label`) }})
                                                        </template>
                                                    </p>
                                                    <p v-else>-</p>
                                                </div>
                                                <div class="column">
                                                    <div class="ui tiny dark grey attached header">{{ $t('scopes.shaft.variables.lowerVent.label') }}</div>
                                                    <p v-if="shaft.attributes.lowerVent.value !== null">{{ shaft.attributes.lowerVent.value }} {{ $config.get('scopes.shaft.variables.lowerVent.label') }}</p>
                                                    <p v-else>-</p>
                                                </div>
                                                <div class="column">
                                                    <div class="ui tiny dark grey attached header">{{ $t('scopes.shaft.variables.floorCount.label') }}</div>
                                                    <p v-if="shaft.attributes.floorCount !== null">{{ shaft.attributes.floorCount }}</p>
                                                    <p v-else>-</p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="column">
                                                    <div class="ui tiny dark grey attached header">{{ $t('scopes.shaft.variables.engineRoom.label') }}</div>
                                                    <p v-if="shaft.attributes.engineRoom !== null">{{ shaft.attributes.engineRoom ? $t('boolean.true') : $t('boolean.false') }}</p>
                                                    <p v-else>-</p>
                                                </div>
                                                <div class="column">
                                                    <div class="ui tiny dark grey attached header">{{ $t('scopes.shaft.variables.ventOrientation.label') }}</div>
                                                    <p v-if="shaft.attributes.ventOrientation !== null">{{ $t(`scopes.shaft.variables.ventOrientation.items.${shaft.attributes.ventOrientation}.label`) }}</p>
                                                    <p v-else>-</p>
                                                </div>
                                                <div class="column">
                                                    <div class="ui tiny dark grey attached header">{{ $t('scopes.shaft.variables.maximumLoad.label') }}</div>
                                                    <p v-if="shaft.attributes.maximumLoad !== null">{{ shaft.attributes.maximumLoad }} {{ $config.get('scopes.shaft.variables.maximumLoad.label') }}</p>
                                                    <p v-else>-</p>
                                                </div>
                                                <div class="column">
                                                    <div class="ui tiny dark grey attached header">{{ $t('scopes.shaft.variables.liftCount.label') }}</div>
                                                    <p v-if="shaft.attributes.liftCount !== null">{{ shaft.attributes.liftCount }}</p>
                                                    <p v-else>-</p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="column">
                                                    <div class="ui tiny dark grey attached header">{{ $t('scopes.shaft.variables.doorType.label') }}</div>
                                                    <p v-if="shaft.attributes.doorType !== null">{{ $t(`scopes.shaft.variables.doorType.items.${shaft.attributes.doorType}.label`) }}</p>
                                                    <p v-else>-</p>
                                                </div>
                                                <div class="column">
                                                    <div class="ui tiny dark grey attached header">{{ $t('scopes.shaft.variables.doorHeight.label') }}</div>
                                                    <p v-if="shaft.attributes.doorHeight !== null">{{ shaft.attributes.doorHeight }} {{ $config.get('scopes.shaft.variables.doorHeight.label') }}</p>
                                                    <p v-else>-</p>
                                                </div>
                                                <div class="column">
                                                    <div class="ui tiny dark grey attached header">{{ $t('scopes.shaft.variables.doorWidth.label') }}</div>
                                                    <p v-if="shaft.attributes.doorWidth !== null">{{ shaft.attributes.doorWidth }} {{ $config.get('scopes.shaft.variables.doorWidth.label') }}</p>
                                                    <p v-else>-</p>
                                                </div>
                                                <div class="column">
                                                    <div class="ui tiny dark grey attached header">{{ $t('scopes.shaft.variables.doorCount.label') }}</div>
                                                    <p v-if="shaft.attributes.doorCount !== null">{{ shaft.attributes.doorCount }}</p>
                                                    <p v-else>-</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </section>
            <section class="ui vertical segment energy-savings" data-no-pagebreak-inside="">
                <div class="ui wide text container">
                    <div class="ui very light grey segment">
                        <ui-accordion class="ui accordion">
                            <ui-accordion-item class="active">
                                <template v-slot:title>
                                    <div class="ui two column middle aligned grid">
                                        <div class="ten wide column">
                                            <div class="ui primary header">{{ $t('components.report.tables.energy.title') }}</div>
                                        </div>
                                        <div class="two wide right aligned column">
                                            <i class="site chevron down link icon"></i>
                                        </div>
                                    </div>
                                </template>
                                <template v-slot:content>
                                    <div class="content">
                                        <div class="ui scrollable segment">
                                            <table class="ui small celled striped unstackable scrollable right aligned table">
                                                <thead>
                                                    <tr>
                                                        <th>{{ $t('components.report.tables.energy.columns.month') }}</th>
                                                        <th>{{ $t('components.report.tables.energy.columns.night') }}</th>
                                                        <th>{{ $t('components.report.tables.energy.columns.day') }}</th>
                                                        <th>{{ $t('components.report.tables.energy.columns.sum') }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(n, i) in 12" v-bind:key="i">
                                                        <td>{{ i | month($i18n.locale) }}</td>
                                                        <td>{{ value(project.scope, 'night-energetic', i) | format($i18n.locale) }}</td>
                                                        <td>{{ value(project.scope, 'day-energetic', i) | format($i18n.locale) }}</td>
                                                        <td>{{ value(project.scope, 'day-energetic', i) + value(project.scope, 'night-energetic', i) | format($i18n.locale) }}</td>
                                                    </tr>
                                                </tbody>
                                                <tfoot>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </div>
                                </template>
                            </ui-accordion-item>
                        </ui-accordion>
                    </div>
                </div>
            </section>
            <section class="ui vertical segment money-savings" data-no-pagebreak-inside="">
                <div class="ui wide text container">
                    <div class="ui very light grey segment">
                        <ui-accordion class="ui accordion">
                            <ui-accordion-item>
                                <template v-slot:title>
                                    <div class="ui two column middle aligned grid">
                                        <div class="ten wide column">
                                            <div class="ui primary header">{{ $t('components.report.tables.money.title', { currency }) }}</div>
                                        </div>
                                        <div class="two wide right aligned column">
                                            <i class="site chevron down link icon"></i>
                                        </div>
                                    </div>
                                </template>
                                <template v-slot:content>
                                    <div class="content">
                                        <div class="ui scrollable segment">
                                            <table class="ui small celled striped unstackable scrollable right aligned table">
                                                <thead>
                                                    <tr>
                                                        <th>{{ $t('components.report.tables.money.columns.month') }}</th>
                                                        <th>{{ $t('components.report.tables.money.columns.night') }}</th>
                                                        <th>{{ $t('components.report.tables.money.columns.day') }}</th>
                                                        <th>{{ $t('components.report.tables.money.columns.sum') }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(n, i) in 12" v-bind:key="i">
                                                        <td>{{ i | month($i18n.locale) }}</td>
                                                        <td>{{ value(project.scope, 'night-monetary', i) | format($i18n.locale) }}</td>
                                                        <td>{{ value(project.scope, 'day-monetary', i) | format($i18n.locale) }}</td>
                                                        <td>{{ value(project.scope, 'day-monetary', i) + value(project.scope, 'night-monetary', i) | format($i18n.locale) }}</td>
                                                    </tr>
                                                </tbody>
                                                <tfoot>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </div>
                                </template>
                            </ui-accordion-item>
                        </ui-accordion>
                    </div>
                </div>
            </section>
            <div class="carbon-savings">
                <section class="ui vertical segment" data-no-pagebreak-inside="">
                    <div class="ui wide text container">
                        <div class="ui very light grey segment">
                            <ui-accordion class="ui accordion">
                                <ui-accordion-item>
                                    <template v-slot:title>
                                        <div class="ui two column middle aligned grid">
                                            <div class="ten wide column">
                                                <div class="ui primary header">{{ $t('components.report.tables.carbon.title') }}</div>
                                            </div>
                                            <div class="two wide right aligned column">
                                                <i class="site chevron down link icon"></i>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-slot:content>
                                        <div class="content">
                                            <div class="ui scrollable segment">
                                                <table class="ui small celled striped unstackable scrollable right aligned table">
                                                    <thead>
                                                        <tr>
                                                            <th>{{ $t('components.report.tables.carbon.columns.month') }}</th>
                                                            <th>{{ $t('components.report.tables.carbon.columns.night') }}</th>
                                                            <th>{{ $t('components.report.tables.carbon.columns.day') }}</th>
                                                            <th>{{ $t('components.report.tables.carbon.columns.sum') }}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(n, i) in 12" v-bind:key="i">
                                                            <td>{{ i | month($i18n.locale) }}</td>
                                                            <td>{{ value(project.scope, 'night-ecologically', i) | format($i18n.locale) }}</td>
                                                            <td>{{ value(project.scope, 'day-ecologically', i) | format($i18n.locale) }}</td>
                                                            <td>{{ value(project.scope, 'day-ecologically', i) + value(project.scope, 'night-ecologically', i) | format($i18n.locale) }}</td>
                                                        </tr>
                                                    </tbody>
                                                    <tfoot>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>
                                    </template>
                                </ui-accordion-item>
                            </ui-accordion>
                        </div>
                    </div>
                </section>
                <div class="ui wide text container pdf-last-section" data-no-pagebreak-inside="">
                    <div class="ui divider"></div>
                    <div class="ui small segment">
                        <p>{{  $t('components.report.disclaimer') }}</p>
                    </div>
                </div>
            </div>
        </div>
        <app-report-pdf v-if="project && !isLocked" v-bind:project="project">
        </app-report-pdf>
    </div>
</template>
<script>

import UiAccordion from './UiAccordion.vue'
import UiAccordionItem from './UiAccordionItem.vue'
import UiChart from './UiChart.vue'
import AppReportPdf from './AppReportPdf.vue'

import Profile from '../Profile.js'

function getTwelveYearRange() {
  return [...Array(12).keys()];
}

export default {
    components: {
        UiAccordion,
        UiAccordionItem,
        UiChart,
        AppReportPdf
    },
    props: {
        project: {
            type: Object,
            required: true
        },
        user: {
            type: Object,
            required: false,
            default: null
        },
    },
    data() {
        return {
            date: new Date()
        }
    },
    filters: {
        format(value, locale) {
            return value.toLocaleString(locale, { minimumFractionDigits: 0, maximumFractionDigits: 0 })
        },
        month(index, locale) {
            let date = new Date()

            date.setDate(1)
            date.setMonth(index)

            return date.toLocaleString(locale, { month: 'long' })
        }
    },
    methods: {
        value(scope, key, index) {
            return this.project.scope.attributes.savings[key][index].value
        },
        values(scope, key) {
            let values = this.project.scope.attributes.savings[key];

            if (key.endsWith('temperature')) {
                values = this.project.scope.attributes.outsideTemperature[key.replace('-temperature', '')];
            }

            return values.map(entry => entry.value.toFixed(2))
        },
        total(scope, key) {
            return [].concat(
                scope.attributes.savings[`day-${key}`].map(entry => entry.value),
                scope.attributes.savings[`night-${key}`].map(entry => entry.value)
            ).reduce((accumulator, current) => accumulator + current)
        },
        amortizations(scope) {
            const anual = this.total(scope, 'monetary')

            return getTwelveYearRange().map(entry => (entry * anual).toFixed(2));
        },
        investments() {
          return this.project.scope.attributes.investment;
        }
    },
    computed: {
        months() {
            return getTwelveYearRange().map((index) => {
                let date = new Date()

                date.setDate(1)
                date.setMonth(index)

                return date.toLocaleString(this.$i18n.locale, { month: 'short' })
            })
        },
        isLocked() {
            return this.$store.state.profile !== Profile.extended
        },
        currency() {
            return this.project.scope.attributes.currency;
        }
    }
}
</script>
